import styled from 'styled-components'

interface IProps {
  value: number
}

export default function TotalScore({ value }: IProps) {
  return (
    <Container>
      <p>{value}</p>
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 7.5%;
  justify-content: center;
  width: 100%;

  & > p {
    color: #000000;
    font-size: 32px;
    font-weight: bold;
  }
`
